import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {},
  },
  iconButtonScrollRight: {
    fontFamily: 'sm',
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    color: 'alpha.700',
    textShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    border: 'none',
    borderRadius: 'sm',
    borderLeftRadius: 'none',
    w: 'auto',
    minW: '4',
    h: '9',
    _hover: {
      bgGradient: 'linear(to-b, #D57E34, #C87935)',
    },
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {},
  },
  iconButtonScrollLeft: {
    fontFamily: 'sm',
    bgGradient: 'linear(to-b, beta.400, beta.500)',
    border: 'none',
    borderRadius: 'sm',
    borderRightRadius: 'none',
    h: '9',
    w: 'auto',
    minW: '4',
    _hover: {
      bgGradient: 'linear(to-b, #D57E34, #C87935)',
    },
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  flexWrapper: {
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  },
  buttonGroupSports: {
    display: 'inline-flex',
    flex: '1',
    alignItems: 'center',
    h: '34px',
    overflowY: 'hidden',
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    overflowX: 'auto',
    p: '1',
    mr: [null, null, null],
    spacing: '1',
    whiteSpace: 'nowrap',
    pos: ['relative', null, null, null],
    w: ['120px', 'auto', null],
    borderRadius: [null, null, 'md'],
    inset: 0,
    sx: { '::-webkit-scrollbar': { display: 'none' } },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    pos: 'relative',
    spacing: '1',
    ml: 'auto',
    gap: 0.5,
    bg: 'none',
    h: '34px',
    isAttached: true,
    variant: 'filter',
  },
};
